import React, { useEffect, useState } from 'react';
import { Grid, Button, Box, TextField } from "@mui/material";
import { styles } from "./styles";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';

interface ActionButtons {
  label: string;
  icon?: any;
  onClickHandler: Function;
  buttonStyle: any;
}
interface dateProps {
  defaultValue?: any;
}
interface TableHeaderProps {
  data: any;
  tabs?: Array<ActionButtons>;
  withFilter?: boolean;
  csvLabel?: string;
  fromDate?: any;
  setFromDate?: any;
  setToDate?: any;
  setErrorReportData?: any;
  truckId?: any;
  deviceId?: any;
  setDeviceId?: any;
  setTruckId?: any;
  formattedData?:any;
  setFormattedData?:any;
  getFailedReports: () => Promise<void>;
}

const ReportsTableHeader: React.FC<TableHeaderProps> = ({ setFromDate, setToDate, truckId, setTruckId, formattedData, setFormattedData, deviceId, setDeviceId, getFailedReports, setErrorReportData, data, tabs, withFilter, csvLabel }) => {
  const [checkedData, setCheckedData] = useState<any>(null);
  const [fromvalue, setFromvalue] = React.useState<Dayjs | null>(dayjs(new Date()));
  const [isFromDateError, setFromDateError] = useState(false);
  const [tovalue, settovalue] = React.useState<Dayjs | null>(dayjs(new Date()));
  const [isToDateError, setToDateError] = useState(false);

  const transformUserRoles = (arr: any) => {
    let transformedArray: any = [];
    arr.forEach((obj: any) => {
      if (obj.hasOwnProperty('userRoleList')) {
        let transformedObj = { ...obj };
        if (transformedObj.hasOwnProperty('userId')) {
          delete transformedObj['userId'];
        }
        if (transformedObj.hasOwnProperty('rfidtag')) {
          delete transformedObj['rfidtag'];
        }
        if (transformedObj.hasOwnProperty('msgtimestamp')) {
          delete transformedObj['msgtimestamp'];
        }
        if (transformedObj.hasOwnProperty('imageurl')) {
          delete transformedObj['imageurl'];
        }
        if (transformedObj.hasOwnProperty('imagefilename')) {
          delete transformedObj['imagefilename'];
        }
        if (transformedObj.hasOwnProperty('imageurl2')) {
          delete transformedObj['imageurl2'];
        }
        if (transformedObj.hasOwnProperty('imagefilename2')) {
          delete transformedObj['imagefilename2'];
        }
        if (transformedObj.hasOwnProperty('errorcategory')) {
          delete transformedObj['errorcategory'];
        }
        if (transformedObj.hasOwnProperty('truckSegmentName')) {
          delete transformedObj['truckSegmentName'];
        }
        if (transformedObj.hasOwnProperty('recordNumber')) {
          delete transformedObj['recordNumber'];
        }
        if (transformedObj.hasOwnProperty('roleId')) {
          delete transformedObj['roleId'];
        }
        if (transformedObj.hasOwnProperty('truckId')) {
          delete transformedObj['roleId'];
        }
        const userRoles = transformedObj['userRoleList'].map((roleObj: any) => roleObj['roleName']);
        transformedObj['userRoleList'] = userRoles.join(', ');
        transformedArray.push(transformedObj);
      }
    });

    if (transformedArray.length > 0) {
      setCheckedData(transformedArray);
    } else {
      setCheckedData(data);
    }
  }

  const transformKey = (key: string) => {
    return key.replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/^./, (str) => str.toUpperCase());
  };

  const transformObjectKeys = (obj: any) => {
    const transformedObj = Object.keys(obj).reduce((acc, key) => {
      const transformedKey = transformKey(key);
      return { ...acc, [transformedKey]: obj[key] };
    }, {});
    return transformedObj;
  };

  useEffect(() => {

    if (checkedData !== null && checkedData.length > 0) {
      let transformedArray = checkedData.map((obj: any) => transformObjectKeys(obj));
      console.log(transformedArray)
      let rArray: any = [];
      let errorsdata: any = [];
      for (var i = 0; i < transformedArray.length; i++) {
        let errorObj: any = {};
        errorObj["RFID Tag"] = transformedArray[i]["Rfidtag"];
        errorObj["Device ID"] = transformedArray[i]["Hostname"];
        errorObj["Error"] = transformedArray[i]["Error"];
        errorObj["Event Date"] = transformedArray[i]["Eventdate"];
        errorObj["Truck Number"] = transformedArray[i]["Truck No"];
        errorObj["Service Provider Name"] = transformedArray[i]["Service Provider Name"];
        errorsdata.push(errorObj);
      }
      setFormattedData(errorsdata);
    }
  }, [checkedData]);

  useEffect(() => {
    if (data.length > 0) {
      transformUserRoles(data);
    }
  }, [data]);

  const getReportsbydate = () => {
    if(isFromDateError || isToDateError) {
      return false;
     }
     if(!fromvalue || !fromvalue.isValid()) {
       setFromDateError(!isFromDateError);
       return false;
     }
     if(!tovalue || !tovalue.isValid()) {
       setToDateError(!isToDateError);
       return false;
     }
     let hours = tovalue.diff(fromvalue, 'hours');
     const days = Math.floor(hours / 24);
     if(days > 6) {
       alert("Date range should not exceed 7 days.");
       return false;
     }
     if(days < 0) {
       alert("Invalid date range.")
       return false;
     }

    setCheckedData([]);
    setFormattedData([]);
    setErrorReportData([]);
    let date: any = fromvalue?.get('date');
    let month: any = fromvalue?.get('month');
    let year: any = fromvalue?.get('year');

    let newMonth = month < 9 ? `0${month + 1}` : `${month + 1}`; //adding 0 to month if single digit
    let newdate = date < 10 ? `0${date}` : `${date}`; //adding 0 to date if single digit
    let fromDate: any = `${newMonth}-${newdate}-${year}`;

    let tdate: any = tovalue?.get('date');
    let tmonth: any = tovalue?.get('month');
    let tyear: any = tovalue?.get('year');

    let tnewMonth = tmonth < 9 ? `0${tmonth + 1}` : `${tmonth + 1}`; //adding 0 to month if it is single digit
    let tnewdate = tdate < 10 ? `0${tdate}` : `${tdate}`; //adding 0 to date if it is single digit
    let toDate: any = `${tnewMonth}-${tnewdate}-${tyear}`;

    setFromDate(fromDate);
    setToDate(toDate);
    localStorage.setItem('fromDate', fromDate);
    localStorage.setItem('toDate', toDate);
    getFailedReports(); // gets data if available
  }
  const onChangeDeviveId = (e: any) => {
    setDeviceId(e);
  }

  const onChangeTruckId = (e: any) => {
    setTruckId(e);
  }

  useEffect(() => {
    setFromDate(fromvalue);
    setToDate(tovalue);
    return () => {
      setFromDate(fromvalue);
      setToDate(tovalue);
    }
  }, [])

  return (
    <Grid xs={12} sx={{...styles.mainContainer}}>
    <Grid item xs={12} sx={{ ...styles.container, justifyContent: tabs ? "space-between" : "flex-end" }}>
        <Grid xs={3} item sx={{ marginRight: '15px', marginTop: '1px' }}>
          <TextField style={{ width: "100%", paddingBottom: "0px" }} label={"Device ID"} value={deviceId}
            onChange={(e) => onChangeDeviveId(e.target.value)} />
        </Grid>
        <Grid xs={3} item sx={{ marginRight: '15px', marginTop: '1px' }}>
          <TextField style={{ width: "100%", paddingBottom: "0px" }} label={"Truck Number"} value={truckId}
            onChange={(e) => onChangeTruckId(e.target.value)} />
        </Grid>
        <Grid xs={6} style={{ marginRight: "15px" }}>
          <Box>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="From"
                openTo="day"
                views={['year', 'month', 'day']}
                value={fromvalue}
                inputFormat="MM-DD-YYYY"
                onChange={(newValue) => {
                  setFromvalue(newValue);
                  setFromDateError(!newValue  || !newValue.isValid());
                }}
                renderInput={(params) => <TextField  {...params} required={true} style={{ marginRight: "15px" }} 
                error={isFromDateError || !fromvalue || !fromvalue.isValid()}
                helperText={isFromDateError ? ( !fromvalue ? "Requried Field.": "Invalid Date."):""}
                />}
              />
              <DatePicker
                label="To"
                openTo="day"
                views={['year', 'month', 'day']}
                value={tovalue}
                inputFormat="MM-DD-YYYY"
                onChange={(newValue) => {
                  settovalue(newValue);
                  setToDateError(!newValue || !newValue.isValid());
                }}
                renderInput={(params) => <TextField {...params} required={true} style={{ marginRight: "0px" }} 
                error={isToDateError || !tovalue || !tovalue.isValid() }
                helperText={isToDateError ? ( !tovalue? "Requried Field.": "Invalid Date."):""}
                />}
              />
            </LocalizationProvider>
          </Box>
        </Grid>
      </Grid>
      <Grid xs={12}>
        <Button sx={styles.buttonGreen} onClick={getReportsbydate}>Search</Button>
      </Grid>
    </Grid>
  )
}

export default ReportsTableHeader;